export const actionTypes = {
    LOGIN: 'USER/LOGIN',
    LOGIN_SUCCESS: 'USER/LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER/LOGIN_FAILURE',
};